
const onRowUpdate = async () => {
 console.log('vatdeduct onRowUpdate')
}

export default onRowUpdate
